import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment'

import { CommentsBodyModal } from './CommentsBodyModal';

interface MyProps {
  onHide(): any;
  show: boolean;
  comments: any;
}

class CommentsViewModal extends React.Component<MyProps> {
  render() {
    const {
      show,
      onHide,
      comments,
    } = this.props;

    return (
      <Modal
        show={show}
        onHide={onHide}
        size='lg'
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
          {
            comments && (
              <>
                <Modal.Header className='modal-header-update modal-header-request p-4 flex-column' closeButton translate="yes">
                  <Modal.Title className='w-100' as="h4" id="example-custom-modal-styling-title">
                    {`"${comments.QuestionText}"`}
                  </Modal.Title>
                  <div className='d-flex align-items-center'>
                    <p className='pr-3 mb-0'>{`By ${comments.Name}`}</p>
                    <p className='mb-0'>{moment(comments.Added).format('D MMM YYYY HH:mm:ss')}</p>
                  </div>
                </Modal.Header>
                {/* {console.log('comments', comments)} */}
                <Modal.Body className='p-0'>
                  <CommentsBodyModal
                    onHide={onHide}
                    answers={comments.NumOfAnswers}
                    agree={comments.NumOfYes}
                    comments={comments.comments}
                  />
                </Modal.Body>
              </>
            )
          }
        <br/>
    </Modal>
    );
  }
}

export { CommentsViewModal };
